export const ONE_TIME_QUERY = ['focus_event', 'exclusive_condition']
export const EXCLUSIVE_CONDITION_QUERY = 'exclusive_condition'
export const EXCLUSIVE_QUERY = ['filter[region]', 'filter[area_group]', 'filter[area]', 'filter[prefecture]']
